import { Controller } from "@hotwired/stimulus";
import Viewer from "viewerjs";

// Connects to data-controller="image-viewer"
export default class extends Controller {
  static targets = ["image"];

  connect() {}

  open() {
    console.log(this.imageTarget);
    const viewer = new Viewer(this.imageTarget);
    viewer.show();
  }
}
